import * as React from "react";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import EditForm from "../../../components/Setting/EditForm";
import ColorPicker from "components/common/ColorPicker/ColorPicker";

const EditActivityTag = (props) => {
  return (
    <EditForm
      type={props.type}
      item={props.item}
      onSubmit={props.onSubmit}
      cancelEdit={props.cancelEdit}
      fields={[
        {
          name: "name",
          component: Input,
          label: "Activity Name",
          validationMessage: "Name is required",
        },
        {
          name: "colour",
          component: ColorPicker,
          label: "Row Color",
        },
        {
          name: "active",
          component: Checkbox,
          label: "Active",
          defaultChecked: true,
          type: "checkbox",
        },
      ]}
      formId="activity-tag-form"
      title="Activity Tags"
    />
  );
};

export default EditActivityTag;
